"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
function check(value) {
    // @ts-ignore
    if (value === "Invalid date") {
        throw new exception_1.RuntimeException("Invalid date given");
    }
    return value;
}
exports.default = check;
//# sourceMappingURL=check.js.map